<script setup lang="ts">
function getParticleStyle(index: number) {
	const seed = index * 1234.5
	const size = (Math.sin(seed) * 2 + 4)
	const left = ((index * 47) % 100)
	const animationDelay = (index * 3.7) % 20
	const animationDuration = 10 + ((index * 2.3) % 10)
	return {
		width: `${Math.abs(size)}px`,
		height: `${Math.abs(size)}px`,
		left: `${left}%`,
		animationDelay: `${animationDelay}s`,
		animationDuration: `${animationDuration}s`,
	}
}
</script>

<template>
	<div class="background-elements">
		<div class="floating-particles">
			<div
				v-for="i in 20"
				:key="i"
				class="particle"
				:style="getParticleStyle(i)"
			/>
		</div>

		<div class="light-gradient gradient-1" />
		<div class="light-gradient gradient-2" />
		<div class="light-gradient gradient-3" />

		<div class="geometric-shape shape-1" />
		<div class="geometric-shape shape-2" />
		<div class="geometric-shape shape-3" />
	</div>
</template>

<style scoped lang="scss">
.background-elements {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.floating-particles {
  position: absolute;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  background: linear-gradient(45deg, #8b5cf6, #ec4899);
  border-radius: 50%;
  opacity: 0.6;
  animation: float infinite linear;
}

@keyframes float {
  0% {
    transform: translateY(100vh) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 0.6;
  }
  90% {
    opacity: 0.6;
  }
  100% {
    transform: translateY(-10vh) rotate(360deg);
    opacity: 0;
  }
}

.light-gradient {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.3;
  animation: pulse 4s ease-in-out infinite;
}

.gradient-1 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, #8b5cf6 0%, transparent 70%);
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.gradient-2 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, #ec4899 0%, transparent 70%);
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.gradient-3 {
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, #06b6d4 0%, transparent 70%);
  bottom: 20%;
  left: 20%;
  animation-delay: 1s;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.5;
  }
}

.geometric-shape {
  position: absolute;
  border: 1px solid rgba(139, 92, 246, 0.3);
  animation: rotate 20s linear infinite;
}

.shape-1 {
  width: 100px;
  height: 100px;
  top: 15%;
  right: 20%;
  transform: rotate(45deg);
}

.shape-2 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 15%;
  border-radius: 50%;
  animation-direction: reverse;
}

.shape-3 {
  width: 60px;
  height: 60px;
  top: 70%;
  right: 10%;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .geometric-shape {
    display: none;
  }
}
</style>
